import React from "react";
import mobileLeaderImg from "../../assets/mobileLeader.jpg";
import sudhaImg from "../../assets/sudhaImg.jpg";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";
import PreLoadingImages from "../custom/PreLoadingImages";

const Leader = () => {
  return (
    <div
      id="leader"
      className="p-[3%] lg:px-[8%] bg-[#ffdddd] lg:py-[4%] flex lg:flex-row-reverse flex-col justify-between items-center w-full relative  lg:mt-[3rem] sm:mt-[2rem] mt-[4rem] "
    >
      <PreLoadingImages images={[sudhaImg]} />
      <div className="w-full lg:w-[60%]">
        <CustomHeading
          text={"Our Leader"}
          textSize="54px"
          textColor="#d31c4f"
          leading="72px"
        />
        <div className="mt-2 sm:mt-3 sm:items-end sm:gap-1 flex sm:flex-row flex-col">
          <CustomHeading
            text={"The Chairperson"}
            textSize="36px"
            leading="50px"
            smTextSize="28px"
          />
          <span className="mb-3 text-3xl sm:block hidden text-[#d31c4f]">
            //
          </span>
          <span className="text-[#d31c4f] mb-1 font-Lato text-[24px] sm:text-[28px] font-light leading-8 sm:leading-[45.60px]">
            transforming the world
          </span>
        </div>
        <CustomContent
          marginTop="0px"
          textAlign="justify"
          textSize="20px"
          leading="32px"
          fontWeight={500}
          textColor="#636363"
          text={
            "When preschools were unheard of, Ms. Sudha Gupta founded Mother’s Pride in 1996, where love blossomed. In 2005, she created Presidium, nurturing future leaders with the philosophy, be what you want to be. She empowered parents when parenting was a challenge and championed life skills over marks. A veteran educationist and parenting expert, she has authored books, contributed as a columnist, and been featured on FM radio and TV for her sought-after parenting programs."
          }
        />
        <CustomContent
          marginTop="5px"
          textAlign="justify"
          textSize="20px"
          leading="32px"
          fontWeight={500}
          textColor="#636363"
          text={
            "Honored with prestigious awards, she has received the Emerging India Award (CNBC), Golden Peacock (London), Outstanding Woman Entrepreneur(FICCI), Jury Choice Award (World Education Summit), and the Majestic Five Continent Award (Berlin)."
          }
        />
      </div>

      <div className="lg:w-[35%] flex justify-center lg:gap-0 gap-3 lg:mt-0 mt-5 items-center flex-col pt-2 ">
        <img
          src={window.innerWidth < 450 ? mobileLeaderImg : sudhaImg}
          alt="leaderImg"
          loading="eager"
          className="lg:w-full w-[380px] h-[260px] object-cover sm:h-[460px] rounded-xl"
        />
        <p
          className="font-bold text-2xl mt-[10px] font-[Quicksand] leading-7 text-center
"
        >
          Ms. Sudha Gupta
        </p>
      </div>
    </div>
  );
};

export default Leader;
